import { all, fork } from "redux-saga/effects";
import type { SagaIterator } from "redux-saga";

import { watchMarketplace } from "./marketplace.sagas";

export default function* rootSaga(): SagaIterator {
  yield all([fork(watchMarketplace)]);
}
